<script>
export default {
    props: {
        proposals: {
            type: Array,
            required: true,
        },
        loading: {
            type: Boolean,
            required: true,
        },
        reportAs: {
            type: String,
            default: ""
        }
    },
    computed: {
        totalPS() {
            return this.proposals.reduce((acc, proposal) => acc + proposal.totalPS, 0);
        },
        totalMOOE() {
            return this.proposals.reduce((acc, proposal) => acc + proposal.totalMOOE, 0);
        },
        totalCO() {
            return this.proposals.reduce((acc, proposal) => acc + proposal.totalCO, 0);
        },
        total() {
            return this.proposals.reduce((acc, proposal) => acc + proposal.total, 0);
        },
        tableTitle() {
            if (this.reportAs === 'groupedByCampus') {
                return "Budget Proposal by Campus"
            } else if (this.reportAs === 'groupedByStructure') {
                return "Budget Proposal by Cost Structure and Campus"
            } else {
                return "Budget Proposal by Delivery Unit"
            }
        }
    }
}
</script>
<template>
    <div>
        <template v-if="loading">
            <div class="d-flex align-items-center justify-content-center" style="height: 300px;">
                <b-spinner label="Loading..."></b-spinner>
            </div>
        </template>
        <template v-else>
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>{{ tableTitle }}</th>
                        <th :style="{ width: '190px' }">Personnel Services</th>
                        <th :style="{ width: '190px' }">MOOE</th>
                        <th :style="{ width: '190px' }">CO</th>
                        <th :style="{ width: '190px' }">Total</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-if="proposals.length">
                        <template v-if="reportAs === 'groupedByCampus'">
                            <template v-for="(proposal, pIndex) in proposals">
                                <tr :key="`A-${pIndex}`">
                                    <td class="font-weight-bold text-white">{{ proposal.campusName }}</td>
                                    <td class="font-weight-bold text-white text-right">{{
                                        formatCurrency(proposal.totalPS)
                                        }}</td>
                                    <td class="font-weight-bold text-white text-right">{{
                                        formatCurrency(proposal.totalMOOE)
                                        }}</td>
                                    <td class="font-weight-bold text-white text-right">{{
                                        formatCurrency(proposal.totalCO)
                                        }}</td>
                                    <td class="font-weight-bold text-white text-right">{{ formatCurrency(proposal.total)
                                        }}
                                    </td>
                                </tr>
                                <template v-for="(classif, cIndex) in proposal.classifications">
                                    <tr :key="`A${pIndex}-B${cIndex}`">
                                        <td class="ps-2"><span class="ms-4 font-weight-bold">{{
                                            classif.prexcClassification
                                                }}</span></td>
                                        <td class="text-right">{{ formatCurrency(classif.totalPS) }}</td>
                                        <td class="text-right">{{ formatCurrency(classif.totalMOOE) }}</td>
                                        <td class="text-right">{{ formatCurrency(classif.totalCO) }}</td>
                                        <td class="text-right">{{ formatCurrency(classif.total) }}</td>
                                    </tr>
                                    <template v-for="(prexc, prexcIndex) in classif.prexces">
                                        <tr :key="`A${pIndex}-B${cIndex}-C${prexcIndex}`">
                                            <td class="ps-4"><span class="ms-4">{{
                                                prexc.prexcName
                                                    }}</span></td>
                                            <td class="text-right">{{ formatCurrency(prexc.totalPS) }}</td>
                                            <td class="text-right">{{ formatCurrency(prexc.totalMOOE) }}</td>
                                            <td class="text-right">{{ formatCurrency(prexc.totalCO) }}</td>
                                            <td class="text-right">{{ formatCurrency(prexc.total) }}</td>
                                        </tr>
                                    </template>
                                </template>
                            </template>
                        </template>
                        <template v-if="reportAs === 'groupedByStructure'">
                            <template v-for="(proposal, pIndex) in proposals">
                                <tr :key="`A-${pIndex}`">
                                    <td class="font-weight-bold text-white">{{ proposal.prexcClassification }}</td>
                                    <td class="font-weight-bold text-white text-right">{{
                                        formatCurrency(proposal.totalPS)
                                        }}</td>
                                    <td class="font-weight-bold text-white text-right">{{
                                        formatCurrency(proposal.totalMOOE)
                                        }}</td>
                                    <td class="font-weight-bold text-white text-right">{{
                                        formatCurrency(proposal.totalCO)
                                        }}</td>
                                    <td class="font-weight-bold text-white text-right">{{ formatCurrency(proposal.total)
                                        }}
                                    </td>
                                </tr>
                                <template v-for="(classif, cIndex) in proposal.prexces">
                                    <tr :key="`A${pIndex}-B${cIndex}`">
                                        <td class="ps-2"><span class="ms-4 font-weight-bold">{{
                                            classif.prexcName
                                                }}</span></td>
                                        <td class="text-right">{{ formatCurrency(classif.totalPS) }}</td>
                                        <td class="text-right">{{ formatCurrency(classif.totalMOOE) }}</td>
                                        <td class="text-right">{{ formatCurrency(classif.totalCO) }}</td>
                                        <td class="text-right">{{ formatCurrency(classif.total) }}</td>
                                    </tr>
                                    <template v-for="(prexc, prexcIndex) in classif.campuses">
                                        <tr :key="`A${pIndex}-B${cIndex}-C${prexcIndex}`">
                                            <td class="ps-4"><span class="ms-4">{{
                                                prexc.campusName
                                                    }}</span></td>
                                            <td class="text-right">{{ formatCurrency(prexc.totalPS) }}</td>
                                            <td class="text-right">{{ formatCurrency(prexc.totalMOOE) }}</td>
                                            <td class="text-right">{{ formatCurrency(prexc.totalCO) }}</td>
                                            <td class="text-right">{{ formatCurrency(prexc.total) }}</td>
                                        </tr>
                                    </template>
                                </template>
                            </template>
                        </template>
                        <template v-if="reportAs === 'groupedByDU'">
                            <template v-for="(proposal, pIndex) in proposals">
                                <tr :key="`A-${pIndex}`">
                                    <td class="font-weight-bold text-white">{{ proposal.prexcClassification }}</td>
                                    <td class="font-weight-bold text-white text-right">{{
                                        formatCurrency(proposal.totalPS)
                                        }}</td>
                                    <td class="font-weight-bold text-white text-right">{{
                                        formatCurrency(proposal.totalMOOE)
                                        }}</td>
                                    <td class="font-weight-bold text-white text-right">{{
                                        formatCurrency(proposal.totalCO)
                                        }}</td>
                                    <td class="font-weight-bold text-white text-right">{{ formatCurrency(proposal.total)
                                        }}
                                    </td>
                                </tr>
                                <template v-for="(classif, cIndex) in proposal.prexces">
                                    <tr :key="`A${pIndex}-B${cIndex}`">
                                        <td class="ps-2"><span class="ms-4 font-weight-bold">{{
                                            classif.prexcName
                                                }}</span></td>
                                        <td class="text-right">{{ formatCurrency(classif.totalPS) }}</td>
                                        <td class="text-right">{{ formatCurrency(classif.totalMOOE) }}</td>
                                        <td class="text-right">{{ formatCurrency(classif.totalCO) }}</td>
                                        <td class="text-right">{{ formatCurrency(classif.total) }}</td>
                                    </tr>
                                    <template v-for="(prexc, prexcIndex) in classif.deliveryUnits">
                                        <tr :key="`A${pIndex}-B${cIndex}-C${prexcIndex}`">
                                            <td class="ps-4"><span class="ms-4">{{
                                                prexc.deliveryUnitName
                                                    }}</span></td>
                                            <td class="text-right">{{ formatCurrency(prexc.totalPS) }}</td>
                                            <td class="text-right">{{ formatCurrency(prexc.totalMOOE) }}</td>
                                            <td class="text-right">{{ formatCurrency(prexc.totalCO) }}</td>
                                            <td class="text-right">{{ formatCurrency(prexc.total) }}</td>
                                        </tr>
                                    </template>
                                </template>
                            </template>
                        </template>
                        <tr>
                            <td class="text-info font-weight-bold">Grand Total</td>
                            <td class="text-info font-weight-bold text-right">{{ formatCurrency(totalPS) }}</td>
                            <td class="text-info font-weight-bold text-right">{{ formatCurrency(totalMOOE) }}</td>
                            <td class="text-info font-weight-bold text-right">{{ formatCurrency(totalCO) }}</td>
                            <td class="text-info font-weight-bold text-right">{{ formatCurrency(total) }}</td>
                        </tr>
                    </template>
                    <template v-else>
                        <tr>
                            <td colspan="100%" class="text-center">No data found.</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </template>
    </div>
</template>